import { NgModule } from '@angular/core';

import { BrowserModule } from '@angular/platform-browser';
import { HttpClientModule } from '@angular/common/http';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { MenuComponent } from './bricks/menu/menu.component';
import { MenuAccountComponent } from './bricks/menu-account/menu-account.component';
import { ThemeToggleComponent } from './bricks/theme-toggle/theme-toggle.component';

import { environment } from 'src/environments/environment';
import { provideFirebaseApp, getApp, initializeApp } from '@angular/fire/app';

import { getAuth, provideAuth } from '@angular/fire/auth';
import { AuthGuard } from './auth/auth.guard';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { LoginComponent } from './login/login.component';
import { CommonModule } from '@angular/common';
import { CookieService } from 'ngx-cookie-service';
import { TokenManagerComponent } from './account/token-manager/token-manager.component';
import { ChatService } from './services/chat.service';
import { MembersComponent } from './auth/members/members.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { ClickAwayDirective } from './directives/click-away.directive';
import { ImpersonationBannerComponent } from './bricks/impersonation-banner/impersonation-banner.component';
import { TwoFactorModalComponent } from './bricks/two-factor-modal/two-factor-modal.component';
import { TwoFactorSetupComponent } from './bricks/two-factor-setup/two-factor-setup.component';
import { BillyConsumptionPanelComponent } from './bricks/billy-consumption-panel/billy-consumption-panel.component';
import { VersionUpdateBannerComponent } from './bricks/version-update-banner/version-update-banner.component';
import { AccountSuspendedBannerComponent } from './bricks/account-suspended-banner/account-suspended-banner.component';
import { EvolutionProposalModalComponent } from './bricks/evolution-proposal-modal/evolution-proposal-modal.component';

@NgModule({
  declarations: [
    AppComponent,
    MenuComponent,
    MenuAccountComponent,
    ThemeToggleComponent,
    TokenManagerComponent,
    LoginComponent,
    MembersComponent,
    ResetPasswordComponent,
    ClickAwayDirective
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    ReactiveFormsModule,
    HttpClientModule,
    FormsModule,
    CommonModule,
    ImpersonationBannerComponent,
    TwoFactorModalComponent,
    TwoFactorSetupComponent,
    BillyConsumptionPanelComponent,
    VersionUpdateBannerComponent,
    AccountSuspendedBannerComponent,
    EvolutionProposalModalComponent
  ],
  providers: [
    AuthGuard,
    CookieService,
    ChatService,
    provideFirebaseApp(() => initializeApp(environment.firebase)),
    provideAuth(() => getAuth(getApp()))
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
